import {format as _format, parseISO as _parseISO} from 'date-fns';
import enUS from 'date-fns/locale/en-US/index'
import sv from 'date-fns/locale/sv/index';
import fi from 'date-fns/locale/fi/index';
import nb from 'date-fns/locale/sv/index';
// import { enUS, sv, fi, nb } from 'date-fns/locale';
import { LANGUAGE } from '../constants';

//==================================================================================
// Module contains localised wrappers for date-fns functions and some custom utils
//==================================================================================

const locales = {
  en: enUS,
  sv,
  fi,
  no: nb,
};

const getLocale = () => locales[LANGUAGE];

export const format = (date, formatStr) => {
  return _format(date, formatStr, { locale: getLocale() });
};


export const parseISO = (date) => _parseISO(date);


